import { useDispatch, useSelector } from "react-redux";
import { Box, Button, SearchIcon, Stack, TextField } from "convertupleads-theme";
import { selectLogState } from "../../state/log/logSelector";
import { deleteLog, setLogDate, setLogLevel, setLogSearchText } from "../../state/log/logSlice";
import debounceHandler from "../../helpers/utils/debounceHandler";
import { Delete } from "@mui/icons-material";
import { Chip } from "@mui/material";

const levels = [
  { value: "", label: "All" },
  { value: "error", label: "Error" },
  { value: "warn", label: "Warning" },
  { value: "info", label: "Info" },
];

const LogHeader = () => {
  const dispatch = useDispatch();
  const {
    filters: { level },
  } = useSelector(selectLogState);

  const onSelectLevel = (value = "") => {
    dispatch(setLogLevel(value));
  };

  const {
    selectedIds,
    filters: { searchText, date },
  } = useSelector(selectLogState);

  const onChangeDate = (e) => {
    const { value } = e.target || {};
    console.log(value);
    dispatch(setLogDate(value));
  };

  const onSearch = (e) => {
    const { value } = e.target || {};
    dispatch(setLogSearchText(value));
  };

  const handleSearch = debounceHandler(onSearch, 1000);

  const handleDeleteLogs = () => {
    if (window.confirm("Are you sure to delete selected logs?")) {
      dispatch(deleteLog({ ids: selectedIds }));
    }
  };

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" mb={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          {levels.map((lavelInfo) => (
            <Chip
              key={lavelInfo.value}
              selected={lavelInfo.value === level}
              label={lavelInfo.label}
              onClick={() => onSelectLevel(lavelInfo.value)}
              variant={"filled"}
              size={"small"}
              color={lavelInfo.value === level ? "primary" : "default"}
            />
          ))}
        </Stack>
        <Box>
          <Stack direction="row" spacing={2} alignItems="center">
            {selectedIds.length > 0 && (
              <Button size="small" variant={"contained"} color={"error"} sx={{ mr: 1 }} startIcon={<Delete />} onClick={handleDeleteLogs}>
                Delete {selectedIds.length || 0}
              </Button>
            )}
            <TextField type="date" defaultValue={date} onChange={onChangeDate} size="small" sx={{ mr: 1 }} />
            <TextField
              type="search"
              placeholder="Search..."
              defaultValue={searchText}
              onChange={handleSearch}
              size="small"
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" color="action" />,
              }}
            />
          </Stack>
        </Box>
      </Stack>
    </>
  );
};

export default LogHeader;
